/** Hidden below `lg` (tablet/mobile) — the row shows the email as subtext under the name instead, so the table never outgrows a tablet. */
const DESKTOP_ONLY = "tw-hidden lg:tw-table-cell";

export const userTableColumnClass = {
  name: "tw-w-[20%] tw-min-w-[12rem]",
  email: `tw-w-[20%] tw-min-w-[12rem] ${DESKTOP_ONLY}`,
  company: `tw-w-[14%] tw-min-w-[9rem] ${DESKTOP_ONLY}`,
  role: "tw-w-[13%] tw-min-w-[8rem]",
  status: "tw-w-[8%] tw-min-w-[5rem]",
  created: `tw-w-[10%] tw-min-w-[7rem] ${DESKTOP_ONLY}`,
  actions: "tw-w-[15%] tw-min-w-[10rem]"
} as const;

export type UserColumnKey = Exclude<keyof typeof userTableColumnClass, "actions">;

/** Name merges the legacy First/Last name columns; the avatar sits beside it. */
export const USER_TABLE_COLUMNS: ReadonlyArray<{ key: UserColumnKey; label: string }> = [
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "company", label: "Company" },
  { key: "role", label: "Role" },
  { key: "status", label: "Status" },
  { key: "created", label: "Created" }
];
